<template lang="pug">
#CreateEditForm
  b-form(@submit.stop.prevent="onSubmit", novalidate)
    b-row
      b-col(cols="6")
        b-form-group#input-group-user(
          label="Usuario",
          label-for="input-user"
        )
          b-form-input#input-user(
            v-model="form.user",
            placeholder="Usuario"
            :state="$v.$dirty ? !$v.form.user.$invalid : null"
          )
          div(v-if="$v.$dirty")
            b-form-invalid-feedback(:state="$v.form.user.required") Este campo es requerido
        b-form-group(
          label="Portal"
          label-for="portal-input"
        )
          b-form-select(
            v-model="form.portal"
            :state="$v.$dirty ? !$v.form.portal.$invalid : null"
            id="portal-input"
            :options="getPortalOptions()"
          )
          div(v-if="$v.$dirty")
            b-form-invalid-feedback(:state="$v.form.portal.required") Este campo es requerido

      b-col(cols="6")
        b-form-group#input-group-password(
          label="Contraseña",
          label-for="input-password"
        )
          b-form-input#input-password(
            v-model="form.password",
            placeholder="Contraseña"
            :state="$v.$dirty ? !$v.form.password.$invalid : null"
          )
          .errors(v-if="$v.$dirty")
            b-form-invalid-feedback(:state="$v.form.password.required") Campo requerido
        b-form-group#input-group-description(
          label="Descripción",
          label-for="input-description"
        )
          b-form-input#input-description(
            v-model="form.description",
          )

    .modal-footer
      b-button(@click="hideModal()", variant="outline-muted") Cancelar
      b-button.boton(type="submit") {{ action === 'create' ? 'Crear' : 'Editar' }}
</template>
<script>
import { required } from "vuelidate/lib/validators";
import { mapActions } from "vuex";
export default {
  props: ["selectedPassword", "action", "hideModal", "makeToast"],
  validations () {
    let validations = {
      form : {
        password: { required },
        portal: { required },
        user: { required }
      }
    }
    return validations
  },
  data() {
    return {
      form: {
        id: this.action === "create" ? null : this.selectedPassword.id,
        password: this.action === "create" ? null : this.selectedPassword.password,
        user: this.action === "create" ? null : this.selectedPassword.user,
        portal: this.action === "create" ? null : this.selectedPassword.portal,
        description: this.action === "create" ? null : this.selectedPassword.description,
        businessId: this.$route.params.id
      },
    };
  },
  methods: {
    ...mapActions(["createPassword", "editPassword"]),
    async onSubmit() {
      if (this.$v.$invalid) {
        this.$v.$touch();
      } else {
        let payload = { ...this.form }
        const action = this.action === "create" ? this.createPassword : this.editPassword;
        const response = await action(payload);

        if (response.status === 200 || response.status === 201) {
          const message = this.action === "create" ?
            'La contraseña ha sido creada exitosamente' : 'La contraseña se editó correctamente'
          this.$root.$bvToast.toast(message, {
            title: 'Exito!',
            variant: 'success'
          })
          this.hideModal();
        } else {
          this.$root.$bvToast.toast(response.data.message, {
            title: 'Oops!',
            variant: 'danger'
          })
        }
      }
    },
    getPortalOptions () {
      const portalOptions = [
        { value: 'sii', text: 'SII'},
        { value: 'DT', text: 'DT'},
        { value: 'previred', text: 'PreviRed'},
        { value: 'other', text: 'Otro' }
        ]
      return portalOptions
    }
  },
};
</script>
